import { Form, FormInstance, Input, message, Modal } from "antd";
import { forwardRef, useEffect, useImperativeHandle, useRef, useState } from "react";
import Server from "../../../server/Server";
import URL from "../../../server/URL";

interface IUpdateMemberName {
    memberID: string,
    name: string,
    reLoad: () => void
}

const UpdateMemberName = forwardRef((props: IUpdateMemberName, ref: any) => {
    const { memberID, name, reLoad } = props;
    const [visible, setVisible] = useState(false);
    const formRef = useRef<FormInstance>(null);

    useImperativeHandle(ref, () => ({
        setVisible
    }));

    useEffect(() => {
        if (visible) {
            formRef.current?.setFieldsValue({ name: name })
        }
    }, [visible])

    const onSave = () => {
        formRef.current?.validateFields().then((values) => {
            var request = {
                memberID: memberID,
                name: values.name
            };
            Server.Post(URL.ComparisonMember.UpdateMemberName, request).then((response: any) => {
                if (response.isSuccess) {
                    message.success('修改成功');
                    reLoad();
                    setVisible(false);
                } else {
                    message.warn(response.returnMsg);
                }
            });
        }).catch(() => { })
    }

    const onCancel = () => {
        setVisible(false);
    }

    return (
        <Modal title={'修改名称'} visible={visible} width={480}
            onCancel={onCancel}
            onOk={onSave}
            maskClosable={false}
            bodyStyle={{ padding: '10px' }}
        >
            <Form ref={formRef}
                labelCol={{ flex: '85px' }}
                labelWrap
                scrollToFirstError={true}>
                <Form.Item label="会员名称" name="name" rules={[{ required: true, message: '请输入名称' }]}>
                    <Input placeholder="请输入名称" />
                </Form.Item>
            </Form>
        </Modal>
    )
});
export default UpdateMemberName;